import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../../helper/helper";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

export default function ViewRouteAlloted() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [selectedUserDetailAssign, setSelectedUserDetailAssign] =
    useState(undefined);
  const [Status, setStatus] = useState({
    approveType: 0,
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: true,
  });
  const customId1 = "custom-id-yes";

  const fetchUserr = async () => {
    try {
      setOpen(true);
      if (Status.approveType == 3) {
        fetchCilent();
      } else if (
        Status.approveType == 1 &&
        Status.approveAssignedType != null
      ) {
        fetchAssigned();
      } else {
        const res = await common_axios(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/route/allocate/list`
        );

        if (res.data.statusDescription.statusCode == 200) {
          setData(res.data.allocatedRouteList);
          setOpen(false);
        } else if (res.data.statusDescription.statusCode == 220) {
          setData([]);
          setOpen(false);
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const fetchCilent = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/senderids/clientRequest`,
        {
          resellerName: Status.resellerName,
          type: Status.type,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData(res.data.listSenderIdRequest);
        setOpen(false);
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const fetchAssigned = async () => {
    try {
      setOpen(true);

      if (Status.approveAssignedType == 1) {
        fetchNotAssigned();
      } else {
        let res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/assigned/senderId/list`,
          {
            type: Status.type,
            resellerName: Status.resellerName,
            approved: Status.approveAssignedType,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setData(res.data.listAssignedSenderId);
          setOpen(false);
        } else if (res.data.statusDescription.statusCode == 220) {
          setData([]);
          setOpen(false);
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        } else {
          setOpen(false);
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const fetchNotAssigned = async () => {
    try {
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/unassigned/senderId/list`,
        {
          type: Status.type,
          resellerName: Status.resellerName,
          approved: Status.approveAssignedType,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setData(res.data.listUnAssignedSenderId);
        setOpen(false);
      } else if (res.data.statusDescription.statusCode == 220) {
        setData([]);
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(async () => {
    fetchUserr();
  }, [Status.approveType]);

  useEffect(async () => {
    if (Status.approveAssignedType != null) {
      fetchAssigned();
    }
  }, [Status.approveAssignedType]);
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelButtonAssign = useRef(null);

  const approveUserModal = async (cell) => {
    cell.row.original.approvedNew = await cell.row.original.approved;
    console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    cell.row.original.approvedNew = await cell.row.original.approved;
    console.log(cell.row.original);

    await setSelectedUserDetail(cell.row.original);
    // selectedUserDetail.approvedNew = 1;
    await modelButtonReject.current.click();
  };
  const assignUserModal = async (cell) => {
    cell.row.original["resellerName"] = "";
    await setSelectedUserDetailAssign(cell.row.original);
    await modelButtonAssign.current.click();
  };

  const rejectUserApi = async (e) => {
    e.preventDefault();
    const buttonn = document.getElementById("close_edit");
    try {
      buttonn.click();
      setOpen(true);
      if (Status.approveType == 3) {
        clientRequestUpdatefunc();
      } else {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/route/allocate/update`,
          selectedUserDetail
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);

          // await toast.success("Route Detail Updated Successfully", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Route Detail Updated Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          fetchUserr();
        } else {
          setOpen(false);
          Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const clientRequestUpdatefunc = async (e) => {
    try {
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/senderid/update/clientReq`,
        {
          id: selectedUserDetail.id,
          senderId: selectedUserDetail.senderId,
          dltId: selectedUserDetail.dltId,
          approved: selectedUserDetail.approvedNew,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);

        // await toast.success("Sender Id Updated Successfully", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Sender Id Updated Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        fetchUserr();
      } else {
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const approveUserApi = async (cell) => {
    const buttonn = document.getElementById("close_edit1");
    try {
      buttonn.click();

      setOpen(true);
      if (Status.approveType == 3) {
        cilentDeleteFunc();
      } else {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/senderid/delete`,
          {
            id: selectedUserDetailApprove.id,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          // await toast.success("Sender Id removed successfully", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Sender Id removed Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          fetchUserr();
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const cilentDeleteFunc = async (cell) => {
    try {
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/senderid/clientReq/delete`,
        {
          id: selectedUserDetailApprove.id,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Sender Id removed Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        fetchUserr();
      } else {
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const assignUserApi = async (e) => {
    const buttonn = document.getElementById("close_edit2");
    e.preventDefault();
    try {
      buttonn.click();
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin-master/v1/assign/senderId`,
        {
          resellerName: selectedUserDetailAssign.resellerName,
          senderId: selectedUserDetailAssign.senderId,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // await toast.success("Sender Id Assigned Successfully", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Sender Id Assigned Successfully",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        fetchUserr();
      } else {
        setOpen(false);
       Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // const rejectUser = async (cpId) => {
  //   const res = await common_axios.post(`/admin/v1/user/reject/`, {
  //     cpId,
  //     rejectReason: "not valid user",
  //   });
  //   await setStatus("rejected");

  //   console.log(res.data);
  // };

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell ) => (
         <>{cell.row.index +1}</>
        ),
      },

      {
        Header: "Route Name",

        accessor: "routeName", // accessor is the "key" in the data
      },
      {
        Header: "Smsc Name",

        accessor: "smscName", // accessor is the "key" in the data
      },
      {
        Header: "Route level",

        accessor: "isDefault",
        Cell: (cell) => {
          return (
            <>
              {!cell.row.original.isDefault ? null : ( // <div className="badge badge_8 bg-warning">Disabled</div>
                <div className="badge badge_8 bg-success">Default</div>
              )}
              {cell.row.original.secondary ? (
                <div className="badge badge_8 bg-warning">Secondary</div>
              ) : null}
            </>
          );
        },
      },
      {
        Header: "Type",

        accessor: "type", // accessor is the "key" in the data
      },
      {
        Header: "Category",

        accessor: "category", // accessor is the "key" in the data
      },
      {
        Header: "Throughput",

        accessor: "throughput", // accessor is the "key" in the data
      },

      {
        Header: "Date",

        accessor: "createdAt",
        Cell: (cell) => {
          return <>{dateFormatter(cell.row.original.createdAt)}</>;
        },
      },

      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {!cell.row.original.status ? (
                <div className="badge badge_8 bg-warning">Disabled</div>
              ) : (
                <div className="badge badge_8 bg-success">Enabled</div>
              )}
            </>
          );
        },
      },

      {
        Header: "Created By",

        accessor: "createdBy",
      },
      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="material-icons opacity-10 size">person</i>
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {/* {cell.row.original.approved != 1 && ( */}
              <li
                onClick={() => {
                  console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  Edit
                </a>
              </li>
              {/* // )} */}
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                >
                  Delete
                </a>
              </li>

              {cell.row.original.assigned == false && (
                <li
                  onClick={() => {
                    console.log(cell);
                  }}
                >
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      assignUserModal(cell);
                    }}
                  >
                    Assign Sender Id
                  </a>
                </li>
              )}
            </ul>
          </div>
        ),

        disableFilters: true,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      {selectedUserDetail != undefined && (
        <div>
          <button
            ref={modelButtonReject}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Are you sure to Update
                  </h5>
                  <button
                    onClick={() => {
                      setSelectedUserDetail(null);
                    }}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <form onSubmit={rejectUserApi}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          SMSC Name:
                        </label>
                        {/* {selectedUserDetail.dltId == null ? ( */}
                        <input
                          required
                          disabled
                          className="form-control"
                          placeholder="smscName Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetail?.smscName}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              smscName: e.target.value,
                            });
                          }}
                        />
                        {/* ) : (
                          <h6 className="text-capitalize">
                            {selectedUserDetail?.dltId}
                          </h6>
                        )} */}
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Throughput
                        </label>
                        <input
                          type="number"
                          disabled
                          required
                          value={selectedUserDetail?.throughput}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              throughput: e.target.value,
                            });
                          }}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Category
                        </label>
                        <input
                          disabled
                          className="form-control"
                          placeholder="category Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetail?.category}
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Type
                        </label>
                        <input
                          disabled
                          className="form-control"
                          placeholder="Type Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetail?.type}
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Created By
                        </label>
                        <input
                          type="text"
                          // required
                          disabled
                          value={selectedUserDetail?.createdBy}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Route Name
                        </label>
                        <input
                          type="text"
                          // required
                          disabled
                          value={selectedUserDetail?.routeName}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              routeName: e.target.value,
                            });
                          }}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Status
                        </label>
                        <select
                          value={selectedUserDetail?.status}
                          className="form-select"
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              status: e.target.value,
                            });
                          }}
                        >
                          {[
                            // {
                            //   id: 0,
                            //   name: "Change Status",
                            //   value: selectedUserDetail?.status,
                            // },

                            {
                              id: 1,
                              name: "Enable",
                              value: "true",
                            },
                            {
                              id: 2,
                              name: "Disable",
                              value: "false",
                            },
                          ].map((d) => {
                            return (
                              <option value={d.value} key={d.id}>
                                {d.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      {/* <div className="col-md-6 "> */}
                      {/* <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value={selectedUserDetail?.isDefault}
                            onChange={(e) => {
                              console.log({ e });
                              setSelectedUserDetail({
                                ...selectedUserDetail,
                                isDefault: e.target.checked ? true : false,
                              });
                            }}
                            checked={selectedUserDetail?.isDefault}
                            id="flexCheckDefault"
                          />
                          <label
                            class="form-check-label"
                            for="flexCheckDefault"
                          >
                            {selectedUserDetail?.isDefault
                              ? "Default"
                              : "Set as Default Route"}
                          </label>
                        </div> */}

                      {/* <label for="exampleInputEmail1" className="form-label">
                          Is Default
                        </label>
                        {selectedUserDetail?.isDefault ? (
                          <button
                            onClick={(e) => {
                              setSelectedUserDetail({
                                ...selectedUserDetail,
                                isDefault: false,
                              });
                            }}
                            type="button"
                            class="btn btn-success "
                          >
                            Default Route
                          </button>
                        ) : (
                          <button
                            onClick={(e) => {
                              setSelectedUserDetail({
                                ...selectedUserDetail,
                                isDefault: true,
                              });
                            }}
                            type="button"
                            class="btn btn-warning "
                          >
                            Set Default Route
                          </button>
                        )} */}
                      {/* </div> */}

                      {!selectedUserDetail?.secondary && (
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Is Primary Route
                          </label>
                          {selectedUserDetail?.isDefault ? (
                            <input
                              type="text"
                              // required
                              style={{
                                background: "#4caf50",
                                color: "white",
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  isDefault: false,
                                });
                              }}
                              value={"Primary Route"}
                              className="form-control "
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          ) : (
                            <input
                              type="text"
                              // required
                              style={{
                                background: "#fc9d26",
                                color: "white",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  isDefault: true,
                                });
                              }}
                              value={"Set Primary Route"}
                              className="form-control "
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          )}
                        </div>
                      )}

                      {!selectedUserDetail?.isDefault && (
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Is Secondary Route
                          </label>
                          {selectedUserDetail?.secondary ? (
                            <input
                              disabled={selectedUserDetail?.isDefault}
                              type="text"
                              // required
                              style={{
                                background: "#4caf50",
                                color: "white",
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  secondary: false,
                                });
                              }}
                              value={"Secondary Route"}
                              className="form-control "
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          ) : (
                            <input
                              disabled={selectedUserDetail?.isDefault}
                              type="text"
                              // required
                              style={{
                                background: "#fc9d26",
                                color: "white",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  secondary: true,
                                });
                              }}
                              value={"Set Secondary Route"}
                              className="form-control "
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          )}
                        </div>
                      )}
                    </div>

                    {/* {!selectedUserDetail?.isDefault && (
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <label
                            for="exampleInputEmail1"
                            className="form-label"
                          >
                            Is Secondary Route
                          </label>
                          {selectedUserDetail?.secondary ? (
                            <input
                              disabled={selectedUserDetail?.isDefault}
                              type="text"
                              // required
                              style={{
                                background: "#4caf50",
                                color: "white",
                                textAlign: "center",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  secondary: false,
                                });
                              }}
                              value={"Secondary Route"}
                              className="form-control "
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          ) : (
                            <input
                              disabled={selectedUserDetail?.isDefault}
                              type="text"
                              // required
                              style={{
                                background: "#fc9d26",
                                color: "white",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={(e) => {
                                setSelectedUserDetail({
                                  ...selectedUserDetail,
                                  secondary: true,
                                });
                              }}
                              value={"Set Secondary Route"}
                              className="form-control "
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                            />
                          )}
                        </div>
                      </div>
                    )} */}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedUserDetail(null);
                      }}
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedUserDetailApprove != undefined && (
        <div>
          <button
            ref={modelButtonApprove}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    Are you sure you want to delete
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setSelectedUserDetailApprove(null);
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Sender Id:
                      </label>
                      {/* {selectedUserDetail.dltId == null ? ( */}
                      <input
                        disabled
                        className="form-control"
                        placeholder="Sender Here"
                        type="text"
                        minLength="3"
                        value={selectedUserDetailApprove?.senderId}
                      />
                      {/* ) : (
                          <h6 className="text-capitalize">
                            {selectedUserDetail?.dltId}
                          </h6>
                        )} */}
                    </div>
                    <div className="col-md-6 mt_2">
                      <label for="exampleInputEmail1" className="form-label">
                        DLT PE Id:
                      </label>
                      <input
                        type="text"
                        disabled
                        value={selectedUserDetailApprove?.dltId}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Category:
                      </label>
                      <input
                        disabled
                        required
                        className="form-control"
                        placeholder="Sender Id Here"
                        type="text"
                        minLength="3"
                        value={selectedUserDetailApprove?.category}
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="exampleInputEmail1" className="form-label">
                        Created By:
                      </label>
                      <input
                        disabled
                        required
                        className="form-control"
                        placeholder="Sender Id Here"
                        type="text"
                        minLength="3"
                        value={selectedUserDetailApprove?.createdBy}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="modal-body">
                  
                  <div className="mt-4">
                    <div className="row justify-content-center align-items-center mx-0 my-3">
                      <div className="col-4 px-0">
                        <h6 className="text-capitalize text-end">Sender Id:</h6>
                      </div>
                      <div className="col-4 px-0 ms-5">
                        <h6 className="text-capitalize">
                          {selectedUserDetailApprove?.senderId}
                        </h6>
                      </div>
                    </div>
                    <div className="row justify-content-center align-items-center mx-0">
                      <div className="col-4 px-0">
                        <h6 className="text-capitalize text-end">DLT PE Id:</h6>
                      </div>
                      <div className="col-4 px-0 ms-5">
                        <h6 className="text-capitalize">
                          {selectedUserDetailApprove?.dltId}
                        </h6>
                      </div>
                    </div>
                    <div className="row justify-content-center align-items-center mx-0 my-3">
                      <div className="col-4 px-0">
                        <h6 className="text-capitalize text-end">Category:</h6>
                      </div>
                      <div className="col-4 px-0 ms-5">
                        <h6 className="">
                          {selectedUserDetailApprove?.category}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div> */}

                <div className="modal-footer justify-content-between">
                  <button
                    type="button"
                    id="close_edit1"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setSelectedUserDetailApprove(null);
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      approveUserApi();
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedUserDetailAssign != undefined && (
        <div>
          <button
            ref={modelButtonAssign}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop2"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop2"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Are you sure
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <form onSubmit={assignUserApi}>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          DLT PE Id:
                        </label>
                        {/* {selectedUserDetail.dltId == null ? ( */}
                        <input
                          disabled
                          className="form-control"
                          placeholder="DLT PE Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailAssign?.dltId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              dltId: e.target.value,
                            });
                          }}
                        />
                        {/* ) : (
                          <h6 className="text-capitalize">
                            {selectedUserDetail?.dltId}
                          </h6>
                        )} */}
                      </div>
                      <div className="col-md-6 mt_2">
                        <label for="exampleInputEmail1" className="form-label">
                          Category
                        </label>
                        <input
                          type="text"
                          disabled
                          value={selectedUserDetailAssign?.category}
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Sender Id
                        </label>
                        <input
                          disabled
                          required
                          className="form-control"
                          placeholder="Sender Id Here"
                          type="text"
                          minLength="3"
                          value={selectedUserDetailAssign?.senderId}
                          onChange={(e) => {
                            setSelectedUserDetail({
                              ...selectedUserDetail,
                              senderId: e.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <label for="exampleInputEmail1" className="form-label">
                          Assign Sender Id to:
                        </label>
                        <Autocomplete
                          fullWidth
                          required
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={data1}
                          // value={Status.resellerName}
                          onChange={(e, val) => {
                            setSelectedUserDetailAssign({
                              ...selectedUserDetailAssign,
                              resellerName: val,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              size="small"
                              label="Select Reseller"
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit2"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Assign
                    </button>
                  </div>
                </form>

                {/* <form onSubmit={assignUserApi}>
                  <div className="modal-body">
                    <div className="mt-4">
                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Sender Id:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.senderId}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">DltId:</h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.dltId}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0 my-3">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Category:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <h6 className="">
                            {selectedUserDetailAssign?.category}
                          </h6>
                        </div>
                      </div>

                      <div className="row justify-content-center align-items-center mx-0">
                        <div className="col-4 px-0">
                          <h6 className="text-capitalize text-end">
                            Assign Sender Id to:
                          </h6>
                        </div>
                        <div className="col-4 px-0 ms-5">
                          <Autocomplete
                            required
                            disablePortal
                            id="combo-box-demo"
                            options={data1}
                            sx={{ width: 200 }}
                            // value={Status.resellerName}
                            onChange={(e, val) => {
                              setSelectedUserDetailAssign({
                                ...selectedUserDetailAssign,
                                resellerName: val,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Select Reseller"
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      id="close_edit"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Assign
                    </button>
                  </div>
                </form> */}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <i className="material-icons opacity-10">person</i>
            </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                View Routes
              </p>
            </div>
          </div>

          <div className="card-body">
            {/* <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 active position-relative"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "0",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Pending
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                    {data2?.admin?.pending == null ? 0 : data2?.admin?.pending}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "1",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Approved
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    {data2?.admin?.approved == null
                      ? 0
                      : data2?.admin?.approved}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "2",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Rejected
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {data2?.admin?.rejected == null
                      ? 0
                      : data2?.admin?.rejected}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "3",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Client Requested
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
                    {data2?.client == null ? 0 : data2?.client}
                  </span>
                </button>
              </li>
            </ul> */}

            {Status.approveType == "1" && (
              <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "0",
                      });
                    }}
                  >
                    Assigned
                    {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                        {data2?.approved}
                      </span> */}
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "1",
                      });
                    }}
                  >
                    Not Assigned
                    {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        99+
                      </span> */}
                  </button>
                </li>
              </ul>
            )}

            <div className="d-flex flex-wrap justify-content-between my-3">
              {Status.hideShow && (
                <>
                  <div className="d-flex">
                    {/* {((Status.approveType == 1 &&
                      Status.approveAssignedType == 0) ||
                      Status.approveType != 1) && (
                      <Autocomplete
                        required
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={data1}
                        sx={{ width: 300 }}
                        // value={Status.resellerName}
                        onChange={(e, val) => {
                          console.log({ val });
                          setStatus({
                            ...Status,
                            resellerName: val,
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            required
                            {...params}
                            label="Select Reseller"
                          />
                        )}
                      />
                    )} */}

                    {/* <div
                      className="d-flex justify-content-between mx-3"
                      style={{ width: "300px" }}
                    >
                      <FormControl fullWidth>
                        <InputLabel size="small" id="test-select-label">
                          Select Type
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={Status.type}
                          label="Select Type"
                          onChange={(e) => {
                            setStatus({
                              ...Status,
                              type: e.target.value,
                            });
                          }}
                        >
                          {[
                            { id: 0, name: "All", value: null },
                            {
                              id: 1,
                              name: "Promotional",
                              value: "Promotional",
                            },
                            {
                              id: 2,
                              name: "Transactional",
                              value: "Transactional",
                            },
                          ].map((d) => {
                            return (
                              <MenuItem value={d.value}> {d.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        disabled={
                          Status.type == null && Status.resellerName == null
                        }
                        onClick={fetchUserr}
                        className={
                          Status.type == null && Status.resellerName == null
                            ? "btn btn-secondary"
                            : "btn btn-primary"
                        }
                      >
                        Filter
                      </button>
                    </div> */}
                  </div>
                </>
              )}

              {/* <div className="text-end" style={{ flexGrow: "1" }}>
                <IconButton
                  variant="text"
                  size="small"
                  sx={{
                    color: "#7B809A",
                  }}
                  onClick={(event) => {
                    setStatus({
                      ...Status,
                      hideShow: !Status.hideShow,
                    });
                  }}
                >
                  {Status.hideShow ? <CancelIcon /> : <SearchIcon />}
                </IconButton>
              </div> */}
            </div>

            {data.length > 0 ? (
              <>
                {Status.hideShow && (
                  <>
                    <div className="d-flex justify-content-between my-3">
                      <div className="d-flex justify-content-between">
                        <select
                          value={pageSize}
                          className="dropdown"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                          }}
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <TextField
                        className="ms-4"
                        style={{
                          borderRadius: "4px",
                        }}
                        type="text"
                        label="Search"
                        name="Search"
                        variant="outlined"
                        // value={number}
                        size="small"
                        value={globalSearchValue || ""}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setGlobalSearchValue(e.target.value);
                        }}
                      />
                    </div>
                  </>
                )}

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  className="text-left"
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {pageIndex + 1} of {pageOptions.length}
                      </strong>
                    </span>
                  </div>

                  {/* <div>
                    <span>
                      Go to Page :
                      <input
                        type="number"
                        // defaultValue={pageIndex + 1}
                        value={pageIndex + 1}
                        onChange={(e) => {
                          const pageNumber = e.target.value
                            ? Number(e.target.value) - 1
                            : 0;
                          gotoPage(pageNumber);
                        }}
                        style={{ width: "50px" }}
                      />
                    </span>
                  </div> */}

                  <div>
                    <button
                      className="btn btn_primary m-0"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={!canPreviousPage}
                      onClick={() => {
                        previousPage();
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary m-0"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={!canNextPage}
                      onClick={() => {
                        nextPage();
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center">
                <h5>Data Not Found</h5>
              </div>
            )}

            <div className="text-end mt-2">
              <p> Allot Route</p>
              <Link
                to="/dashboard/AllotRoute"
                style={{ color: "#63B7E6", marginLeft: "30px" }}
              >
                <span>Click here !!!</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
